// extracted by mini-css-extract-plugin
export default {"container":"ClickContainer_container__lsuvj"};